<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-lightborder table-striped table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Nit</th>
          <th>Cliente</th>
          <th>Fecha</th>
          <th>Caja</th>
          <th>Serie</th>
          <th>Monto</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="current in dataTabla.results"
          v-bind:key="current.id"
          @click="rowClick(current)"
        >
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda.nombre }}</td>
          <td>{{ current.cliente.nit }}</td>
          <td>{{ current.cliente.nombre }}</td>
          <td>{{ current.fecha }}</td>
          <td>{{ current.pedido_e.caja }}</td>
          <td>{{ current.cargo_serie.serie }}</td>
          <td>{{ current.valor_total }}</td>
          <td class="text-center">
            <div
              data-title="Activo"
              data-toggle="tooltip"
              v-html="current.estado_str"
            ></div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent
      :currentPage="currentPage"
      :data="dataTabla"
      @pagechanged="onPageChange"
    />
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAdddevolucion"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Devoluciones</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.caja,
                      }"
                      >Caja</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="current.caja"
                      @change="refreshCaja"
                      @input="$emit('input', $event.target.value)"
                    >
                      <option v-for="(c, key) in caja" :value="c.id" :key="key">
                        Caja: {{ c.caja }} - Tienda {{ c.tienda.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.caja"
                      class="form-text text-danger"
                      >{{ current.errors.caja }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Observación</label>
                    <textarea
                      v-model="current.observacion"
                      class="form-control"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.observacion"
                      class="form-text text-danger"
                      >{{ current.errors.observacion[0] }}</small
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="guardarDevolucion"
              type="button"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModalDetalle"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CargosService from "@/services/cxc/CargosService";
import DevolucionesService from "@/services/inventario/DevolucionesService";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      current: {
        errors: {
          observacion: "",
        },
      },
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  computed: {
    ...mapGetters({
      dataTabla: "cargos/cargos",
      caja: "cargos/caja",
    }),
  },
  mounted() {
    this.$store.dispatch("cargos/fetch");
  },
  methods: {
    refreshCaja() {
      let self = this;
      self.$store.dispatch("cargos/caja", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    refreshCurrentDevoluciones() {
      let self = this;
      DevolucionesService.getById(this.$route.params.id).then((response) => {
        self.current.observacion = response.data.observacion;
        self.current.caja = response.data.caja.caja;
        self.current.cargo_numero =
          response.data.devolucionclienteecargoe_set[0].cargo_e.numero;
      });
    },

    guardarDevolucion(e) {
      e.preventDefault();
      let self = this;
      let current = Object.assign({}, self.current);
      CargosService.getById(current.cargo_id).then((response) => {
        self.current.cargo_d = response.data.cxccargod_set;
      });
      DevolucionesService.save(current)
        .then((response) => {
          self.$refs.cerrarModalDetalle.click();
          self.$router.push({
            name: "inventario-devoluciones-editar",
            params: { id: response.data.id },
          });
          self.refreshCurrent();
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          if (self.current.errors.devolucion_cliente) {
            Notifications.alert.error(
              "Error",
              self.current.errors.devolucion_cliente
            );
          }
        });
    },

    rowClickDevolucion() {
      let self = this;
      self.$router.push({
        name: "inventario-devoluciones-nuevo",
        params: { cargo: current.id },
      });
    },

    rowClick(current) {
      let self = this;
      self.current.cargo_id = current.id;
      self.refreshCaja();
      $("#modalAdddevolucion").modal();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("cargos/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>
